import { render, staticRenderFns } from "./organFrom.vue?vue&type=template&id=6a8d9812&scoped=true"
import script from "./organFrom.vue?vue&type=script&lang=js"
export * from "./organFrom.vue?vue&type=script&lang=js"
import style0 from "./organFrom.vue?vue&type=style&index=0&id=6a8d9812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8d9812",
  null
  
)

export default component.exports